<template>
  <div class="finance_box" ref="myElementRef">
    <div ref="searchBox" v-if="state.flng">
      <hc-search :data="serchData" @serch="getSarch($event)" @getadd="getadd($event)" />
    </div>
    <!-- 表格 -->
    <div class="table_box">
      <hc-table 
        :tableData="tableData" 
        :column="state.tableHeader" 
        :offsetHeight="state.offsetHeight"
        :maxPage="maxPage"
        @pageChange="pageChange($event)"
        @limitChange="limitChange($event)"
      >
        <template #device_img_url="{ row }">
          <el-image 
            v-if="row.device_img_url" 
            :src="row.device_img_url" 
            :preview-src-list="[row.device_img_url]"
            style="width: 50px; height: 50px; border-radius: 4px;"
            fit="cover"
            preview-teleported
            referrerpolicy="no-referrer"
          />
          <span v-else>-</span>
        </template>
        <template #device_png_url="{ row }">
          <el-image 
            v-if="row.device_png_url" 
            :src="row.device_png_url" 
            :preview-src-list="[row.device_png_url]"
            style="width: 50px; height: 50px; border-radius: 4px; background-color: #f5f7fa;"
            fit="contain"
            preview-teleported
            referrerpolicy="no-referrer"
          />
          <span v-else>-</span>
        </template>
        <template #status="{ row }">
          <el-tag :type="row.status == 1 ? 'success' : 'danger'">
            {{ row.status == 1 ? '启用' : '禁用' }}
          </el-tag>
        </template>
        <template #operation="scope">
          <div class="btn_box_det">
            <el-button size="small" type="text" @click="edit(scope.row)">编辑</el-button>
            <el-button size="small" type="danger" link @click="del(scope.row)">删除</el-button>
          </div>
        </template>
      </hc-table>
    </div>
    
    <el-dialog align-center v-model="dialogVisible" title="设备分类信息" width="550" draggable>
      <div class="userAdd_man">
        <el-form label-width="auto" :model="formLabelAlign" class="userFrom" ref="formRef" :rules="rules">
          <el-form-item label="分类编码" prop="device_code">
            <el-input v-model="formLabelAlign.device_code" placeholder="请输入分类编码" />
          </el-form-item>
          <el-form-item label="分类名称" prop="device_name">
            <el-input v-model="formLabelAlign.device_name" placeholder="请输入分类名称" />
          </el-form-item>
          
          <el-form-item label="状态">
            <el-select v-model="formLabelAlign.status" placeholder="请选择">
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>

          <el-form-item label="设备大图">
            <hc-image-upload v-model="formLabelAlign.device_img_url" />
          </el-form-item>

          <el-form-item label="设备png图">
            <hc-image-upload v-model="formLabelAlign.device_png_url" />
          </el-form-item>

          <el-form-item label="备注">
            <el-input type="textarea" :rows="3" v-model="formLabelAlign.remark" placeholder="请输入备注" />
          </el-form-item>
        </el-form>
      </div>

      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="subimt($refs.formRef)">
            确定
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import hcSearch from "@/components/hc-search/index.vue";
import hcTable from "@/components/hc-table/index.vue";
import hcImageUpload from "@/components/hc-image-upload/index.vue";
import { onMounted, reactive, ref, nextTick, onUnmounted } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { 
  EquipmentClassificationAdd, 
  EquipmentClassificationList, 
  EquipmentClassificationDel 
} from '@/api/equipmentClassification.js';

const myElementRef = ref();
const searchBox = ref();
let page = ref(1);
let limit = ref(20);
let maxPage = ref(0);
const dialogVisible = ref(false);

const rules = reactive({
  device_code: [
    { required: true, message: "分类编码不能为空", trigger: "blur" },
  ],
  device_name: [
    { required: true, message: "分类名称不能为空", trigger: "blur" },
  ],
});

const statusOptions = [
  { label: "禁用", value: 0 },
  { label: "启用", value: 1 },
];

const tableData = ref([]);

const serchData = reactive([
  {
    label: "分类名称",
    type: "input",
    value: "",
  },
  {
    label: "",
    type: "add",
    value: true
  }
]);

const state = reactive({
  title: "",
  column: [
    {
      type: "index",
      show: true,
      label: "序号",
      width: 80,
    },
    {
      prop: "device_code",
      show: true,
      label: "设备分类编码",
      width: 200,
    },
    {
      prop: "device_name",
      show: true,
      label: "设备分类名称",
      width: 200,
    },
    {
      prop: "device_img_url",
      show: true,
      label: "设备大图",
      width: 200,
    },
    {
      prop: "device_png_url",
      show: true,
      label: "设备png图",
      width: 200,
    },
    {
      prop: "status",
      show: true,
      label: "状态",
      width: 200,
    },
    {
      prop: "remark",
      show: true,
      label: "备注",
      width: 200,
    },
    {
      prop: "created_at",
      show: true,
      label: "创建时间",
      width: 260,
    },
    {
      prop: "operation",
      show: true,
      label: "操作",
      width: 140, 
    },
  ],
  flng: true,
  offsetHeight: 0,
  tableHeader: [],
});

const formLabelAlign = reactive({
  id: 0,
  device_code: "",
  device_name: "",
  device_img_url: "",
  device_png_url: "",
  status: 1,
  remark: ""
});

// 动态改变表头
const change = (item) => {
  tableHeaderFn();
};

onMounted(() => {
  try {
    nextTick(() => {
      offHeighths();
    });
    window.onresize = () => {
      nextTick(() => {
        offHeighths();
      });
    };
    tableHeaderFn();
  } catch { }
  getList();
});

const offHeighths = () => {
  if (myElementRef.value) {
    state.offsetHeight =
      myElementRef.value?.offsetHeight - 130 - searchBox.value?.offsetHeight;
  }
};

onUnmounted(() => {
  window.onresize = null;
});

const getadd = () => {
  Object.assign(formLabelAlign, {
    id: 0,
    device_code: "",
    device_name: "",
    device_img_url: "",
    device_png_url: "",
    status: 1,
    remark: ""
  });
  dialogVisible.value = true;
};

const edit = async (row) => {
  Object.assign(formLabelAlign, {
    id: row.id,
    device_code: row.device_code,
    device_name: row.device_name,
    device_img_url: row.device_img_url,
    device_png_url: row.device_png_url,
    status: row.status,
    remark: row.remark
  });
  dialogVisible.value = true;
};

// 查询
const getSarch = (data) => {
  page.value = 1;
  getList();
};

const pageChange = (currentPage) => {
  page.value = currentPage;
  getList();
};

const limitChange = (currentLimit) => {
  page.value = 1;
  limit.value = currentLimit;
  getList();
};

// 表头筛选
const tableHeaderFn = () => {
  state.tableHeader = state.column.filter((v) => {
    if (v.show) {
      return v.show == true;
    } else {
      v.show = false;
    }
  });
};

const getList = async () => {
  const res = await EquipmentClassificationList({
    current: page.value,
    size: limit.value,
    deviceName: serchData[0].value
  });
  if (res.code === 200 && res.data) {
    tableData.value = res.data.records || [];
    maxPage.value = res.data.total || 0;
  } else {
    tableData.value = [];
    maxPage.value = 0;
  }
};

const subimt = async (formEl) => {
  if (!formEl) return;

  await formEl.validate(async (valid) => {
    if (valid) {
      try {
        const data = { ...formLabelAlign };
        const res = await EquipmentClassificationAdd(data);
        if (res.code === 200) {
          dialogVisible.value = false;
          ElMessage.success('保存成功');
          getList();
        } else {
          ElMessage.error(res.msg || '保存失败');
        }
      } catch (error) {
        ElMessage.error('保存失败，请重试');
      }
    } else {
      ElMessage.warning('请填写完整的信息');
    }
  });
};

const del = (row) => {
  ElMessageBox.confirm('确认要删除该设备分类信息吗？', '删除提醒', {
    confirmButtonText: '确认',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    getDel(row);
  }).catch(() => {});
};

const getDel = async (row) => {
  const res = await EquipmentClassificationDel({
    id: row.id
  });
  if (res.code === 200) {
    ElMessage.success('删除成功');
    getList();
  } else {
    ElMessage.error(res.msg || '删除失败');
  }
};
</script>

<style lang="less" scoped>
.finance_box {
  flex: 1;
  overflow: auto;
  background-color: #fff;
  border-radius: 6px;
  padding: 10px;
  margin-right: 10px;
}

.btn_box {
  height: 40px;
  display: flex;
}

.table_box {
  width: 100%;
  /deep/ .el-image {
    cursor: pointer;
  }
}

/deep/.el-button-group .el-button--primary:first-child {
  background-color: #1e6aed;
  border: none;
}

.serBtn {
  margin-left: 10px;
  background-color: #f0f0f0;
  color: #000;
  border: none;
}

.serBtn:hover {
  background-color: #f0f0f0;
  color: #000;
}

.opBtn {
  margin: 0 !important;
}

.opBtn:hover {
  color: #e6a755;
}

.userAdd_man {
  min-height: 360px;
  overflow: auto;
  padding: 0 30px;
}

.userFrom {
  display: grid;
  gap: 20px;
  grid-template-columns: 1fr;
}

.el-form-item {
  margin-bottom: 0;
}
</style>
